<template>
  <div @click="handleUpload" class="f-width">
    <v-file-input
      ref="uploadFile"
      class="d-none"
      v-model="uploadItem"
      truncate-length="15"
      :accept="['.jpg', '.png']"
      @change="handleLoadImg"
    ></v-file-input>
    <v-input
      :placeholder="placeholder"
      :messages="[message]"
      @keydown="($event) => $event.preventDefault()"
      class="upload-file-input"
      v-model="fileName"
    >
      <template #append>
        <v-icon size="16px" class="mt-1 neutral-60--text">panda-upload</v-icon>
      </template>
    </v-input>
  </div>
</template>

<script>
export default {
  name: 'BaseUploadFileInput',
  data() {
    return {
      fileName: '',
      uploadItem: null,
    }
  },
  watch: {
    uploadItem(val) {
      if (val) {
        this.fileName = val.name
      } else {
        this.fileName = ''
      }
      this.$emit('input', val)
    },
  },
  props: {
    placeholder: {
      type: String,
      default: 'Selecione uma imagem',
    },
    message: {
      type: String,
      default: 'Formato PNG ou JPG de até 720 x 256px',
    },
  },
  methods: {
    handleUpload() {
      this.$refs.uploadFile.$el.querySelector('input').click()
    },
    handleLoadImg(file) {
      if (file) {
        const imageUrl = URL.createObjectURL(file)
        this.$emit('update', imageUrl)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .upload-file-input {
  cursor: pointer;
  input {
    max-width: -webkit-fill-available;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    cursor: pointer !important;
    caret-color: transparent !important;
  }
}
</style>
